module.exports = __webpack_public_path__ + "static/media/header_ksx.24e4c684.svg";